import React from 'react'
import { IonRow, IonCol } from '@ionic/react'
import content from 'util/content'

const PendingTaskCardEmpty = () => {
  return <IonRow>
    <IonCol size="12">
      <h2 className="Heading_3 text_cyan">{content.get('PROFILE_TASK.EMPTY.TITLE')}</h2>
    </IonCol>
    <IonCol size="12"
      size-lg="8"
      size-md="10">
      <p className="Body_1 text_dark_grey">{content.get('PROFILE_TASK.EMPTY.CONTENT')}</p>
    </IonCol>
  </IonRow>
}

export default PendingTaskCardEmpty
